import { ElMessage } from "element-plus"
import * as _ from "lodash"
/**
 * @param msg 提示信息
 * @param type 类型  success error warning info
 */
let sjyAlert3 = _.throttle(
  (msg: string, types = "success", goTo: any = () => { }) => {
    if (
      types == "success" ||
      types == "error" ||
      types == "warning" ||
      types == "info"
    ) {
      ElMessage(
        {
          message: msg,
          grouping: true,
          type: types,
          duration: 2000,
        },
        goTo()
      )
    }
  },
  4000
) //防抖

let sjyAlert2 = (msg: string, types = "success", goTo: any = () => { }) => {
  if (
    types == "success" ||
    types == "error" ||
    types == "warning" ||
    types == "info"
  ) {
    ElMessage(
      {
        message: msg,
        grouping: true,
        type: types,
        duration: 2000,
      },
      goTo()
    )
  }
}

let sjyAlert = _.debounce(sjyAlert2, 500) //节流

let fangankefu = () => {
  window.open(
    "https://affim.baidu.com/unique_33831074/chat?siteId=19405564&userId=33831074&siteToken=88a9994acc3e52c4f2429b5e1c4abef2",
    "",
    "modal=yes,width=800,height=650,resizable=no,scrollbars=no"
  )
}
let shouqiankefu = () => {
  window.open(
    "https://affim.baidu.com/unique_33831074/chat?siteId=18759370&userId=33831074&siteToken=723bf48ddabadd55e50451682c5fd1d5",
    "",
    "modal=yes,width=800,height=650,resizable=no,scrollbars=no"
  )
}

let shouhoukefu = () => {
  window.open(
    "https://affim.baidu.com/unique_33831074/chat?siteId=18730976&userId=33831074&siteToken=ff070ac69a4150b0da09df302c5ad48d",
    "",
    "modal=yes,width=800,height=650,resizable=no,scrollbars=no"
  )
}

export { sjyAlert, fangankefu, shouqiankefu, shouhoukefu }
